module.exports = __webpack_public_path__ + "static/img/o5.93b3798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/o5.jpg
// module id = 6QCf
// module chunks = 0